import { requestS3URL } from '../../../services/web-api-client';
import { CloudFrontSigner } from '../../../utils/cloud-front-signer/cloud-front-signer';
import { TileNode, TileSet } from '../../../viewer/loader/cesium/tile-set/types';
import { CesiumStore } from './cesium-point-cloud-store';

/**
 *  Downloads the Cesium tile set from CloudFront url.
 */
export class SignedCloudFrontCesiumStore implements CesiumStore {
  constructor(private cesiumCloudFrontSigner: CloudFrontSigner) {}

  /**
   *  Returns the tile set object from backend where each child contains a pre-signed url for its data.
   *  @param path - The path for the tile set file.
   */
  async fetchTileSet(path: string): Promise<TileSet> {
    const tileSet = JSON.parse(
      (await requestS3URL(this.cesiumCloudFrontSigner.getSignedRequest(path))).data,
    );

    const relativePath = path.slice(0, path.lastIndexOf('tileset.json'));

    const relateTileSetToNodes = (tileNode: TileNode) => {
      tileNode.parentTileSet = tileSet as unknown as TileSet;

      if (tileNode.content?.uri) {
        tileNode.content.signedUrl = this.cesiumCloudFrontSigner.getSignedRequest(
          relativePath + tileNode.content.uri,
        );
      }
      for (const child of tileNode.children || []) {
        relateTileSetToNodes(child);
      }
    };

    // Need to cast to client defined TileSet & TileNode
    // TODO: Refactor to depend on backend types
    relateTileSetToNodes(tileSet.root as unknown as TileNode);
    tileSet.relativePath = path.slice(0, path.lastIndexOf('tileset.json'));

    return tileSet as unknown as TileSet;
  }
}
